<template>
  <article class="layout-section">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">Layout Section</h2>
      <p class="type-code">_layout-section.scss</p>
    </div>

    <ul class="list">
      <h6 class="list__title">Image Option</h6>
      <li class="list__item">
        Use the modifier
        <span class="type-code">-align-side</span>
      </li>
      <li class="list__item">
        Add a
        <span class="type-code">&lt;figure/></span>
        with the class
        <span class="type-code">layout-section__figure</span>
      </li>
      <li class="list__item">
        Make sure your content (everything exept the figure) is wrap in a tag with the class
        <span class="type-code">layout-section__content</span>
      </li>
      <li class="list__item">
        Edit your background image directly in the html using
        <span class="type-code">style="background-image: url('');"</span>
      </li>
    </ul>

    <ul class="list">
      <h6 class="list__title">Background Option</h6>
      <li class="list__item">
        Always use the modifier
        <span class="type-code">-bg-full</span>
        for the responsive
      </li>
      <li class="list__item">Add the modifier off your choice for the color or background</li>
      <li class="list__item">
        Make sure all your content is wrap in a tag with the class
        <span class="type-code">layout-section__container-bg-full</span>
      </li>
    </ul>

    <ul class="list">
      <h6 class="list__title">Center Option (CTA)</h6>
      <li class="list__item">
        Use the modifier
        <span class="type-code">-align-center</span>
      </li>
      <li class="list__item">Don't wrap your content, the modifier use flexbox</li>
    </ul>
  </article>
</template>

<script>
export default {
  name: 'DemoSection'
}
</script>
